import React from 'react'

const Form = props => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Name</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="name" value={props.name} onChange={props.onChange} placeholder="eg Draft, Supplementary Materials" />
                        <span className="error">{props.errors.name}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>File (msword, pdf, jpeg)</label>
                    </div>
                    <div className="form-input">
                        <input type="file" name="file" accept="image/jpeg,.doc,.docx,.pdf" onChange={e => props.onChange({
                            target: {
                                name: 'file',
                                value: e.target.files[0]
                            }
                        })} />
                        <span className="error">{props.errors.file}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="submit">Add File</button>
                <button type="reset" onClick={props.onCancel}>Cancel</button>
            </div>
        </form>
    )
}

export default Form